import CyberSecurityPage from "./cyber-security.page"

export default CyberSecurityPage;
